import 'select2';

export default function () {
    $(() => {
        const processElements = () => {
            let elems = $('.form-select[multiple]');
            elems.each((i: number, target: HTMLElement) => {
                const $elem = $(target);
                if (!$elem.data('form-select-processed')) {
                    $elem.data('form-select-processed', true);
                    $elem.select2({width: '250px'});
                }
            });
        };
        
        processElements();
        
        let observer = new MutationObserver(function(mutations, observer) {
            let doProcess = false;
            
            for (const mutation of mutations) {
                if (mutation.type === "childList") {
                    doProcess = true;
                }
            }
            
            if (doProcess) {
                processElements();
            }
        });
        
        observer.observe(document, {
            subtree: true,
            childList: true
        });
    });
}

